var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import { jsx } from "react/jsx-runtime";
import { IconButton } from "@ane/ui-components";
import { OptionsMenu } from "@ane/ui-components/lib/components/OptionsMenu";
import { ResizeGroup } from "@ane/ui-components/lib/components/ResizeGroup";
const ResizeGroupAs = ({ ariaLabelForGroup, data, onRenderData }) => {
  const buttonData = {
    primaryItems: [...data != null ? data : []],
    overflowItems: []
  };
  const onReduceData = (currentData) => {
    var _a;
    const { primaryItems, overflowItems } = currentData;
    if (((_a = data == null ? void 0 : data.length) != null ? _a : 0) > 0 && primaryItems.length > 0) {
      const movedItem = primaryItems[primaryItems.length - 1];
      const newPrimaryItems = primaryItems.slice(0, primaryItems.length - 1);
      const newOverflowItems = [movedItem, ...overflowItems];
      return { primaryItems: newPrimaryItems, overflowItems: newOverflowItems };
    }
    return void 0;
  };
  const onGrowData = (currentData) => {
    var _a;
    const { primaryItems, overflowItems } = currentData;
    if (((_a = data == null ? void 0 : data.length) != null ? _a : 0) > 0 && overflowItems.length > 0) {
      const movedItem = overflowItems[0];
      const newPrimaryItems = [...primaryItems, movedItem];
      const newOverflowItems = overflowItems.slice(1);
      return { primaryItems: newPrimaryItems, overflowItems: newOverflowItems };
    }
    return void 0;
  };
  const onRenderItem = (item) => {
    return /* @__PURE__ */ jsx(IconButton, __spreadValues({}, item));
  };
  const onRenderOverflowButton = (overflowItems = []) => {
    return /* @__PURE__ */ jsx(
      OptionsMenu,
      {
        ariaLabel: `More options for ${ariaLabelForGroup}`,
        title: `More options for ${ariaLabelForGroup}`,
        menuIconProps: { iconName: "More" },
        menuProps: { items: overflowItems }
      }
    );
  };
  return /* @__PURE__ */ jsx(
    ResizeGroup,
    {
      data: buttonData,
      onReduceData,
      onGrowData,
      onRenderData: (data2) => onRenderData(data2, onRenderItem, onRenderOverflowButton)
    }
  );
};
export {
  ResizeGroupAs
};
//# sourceMappingURL=ResizeGroupAs.js.map
